import { RequestConstants } from "../../../../core/request/RequestConstants";
import { WebRequest } from "../../../../core/request/WebRequest";
import { ProgressiveJackpotResponseData } from "../response/data/ProgressiveJackpotResponseData";
/**
 * ProgressiveJackpotRequest.ts
 */
export class ProgressiveJackpotRequest extends WebRequest {
    constructor(requestData) {
        super(ProgressiveJackpotRequest.URL, requestData);
    }
    getMethod() {
        return RequestConstants.POST;
    }
    getDataClass() {
        return ProgressiveJackpotResponseData;
    }
}
ProgressiveJackpotRequest.URL = "/gamecloud-servlets/api/game/jackpot";
//# sourceMappingURL=ProgressiveJackpotRequest.js.map